import { EnvironmentUrls } from 'Roblox';

const { apiGatewayUrl } = EnvironmentUrls;

const url = {
  getExperimentationValues: (projectId, layerName, values) => ({
    url: `${apiGatewayUrl}/product-experimentation-platform/v1/projects/${projectId}/layers/${layerName}/values?parameters=${values.join(
      ','
    )}`,
    withCredentials: true,
    timeout: 2000
  })
};

const layerNames = {
  avatarShopPage: 'AvatarMarketplace.UI'
};

const parameterNames = {
  recommendationNumRows: ['recommendationNumRows', 'recommendationPageName']
};

const defaultProjectId = 1;

export default {
  url,
  parameterNames,
  layerNames,
  defaultProjectId
};
